import BaseComponent from '../abstracts/BaseComponent';

export default class StoryVideo extends BaseComponent {
  constructor(element) {
    super(element);

    this.overlay = element.querySelector('.video-overlay');
    this.modal = element.querySelector('.js-video-modal');
    this.iframe = element.querySelector('#youtube-video');

    this.overlay.addEventListener('click', () => this.onPlayClick());
    this.modal.addEventListener('click', () => this.closeVideoModal());

    // INIT YOUTUBE API
    this.loadYouTubeAPI();
    this.initYoutubePlayer();
  }


  loadYouTubeAPI() {
    //const script = document.querySelector('script');
    if (!window.youTubeAPILoaded) {
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      window.youTubeAPILoaded = true;
    }
  }

  createPlayer() {
    this.player = new YT.Player(this.iframe, {
      height: '85%',
      width: '85%',
      playerVars: {
        controls: 0,
        rel: 0,
        showInfo: 0
      }
    });
  }

  initYoutubePlayer() {
    if (window.YT && window.YT.Player) {
      this.createPlayer();
    } else {
      // ADD CALLBACK TO CALL WHEN API IS READY
      window.onYouTubeIframeAPIReadyCallbacks = window.onYouTubeIframeAPIReadyCallbacks || [];
      window.onYouTubeIframeAPIReadyCallbacks.push(() => this.createPlayer());

      if (!window.onYouTubeIframeAPIReady) {
        // SET API FUNCTION GLOBALLY
        window.onYouTubeIframeAPIReady = () => {
          window.onYouTubeIframeAPIReadyCallbacks.forEach(callback => callback());
        };
      }
    }
  }

  onPlayClick() {
    this.modal.style.display = 'block';
    if (this.player && this.player.playVideo) {
      this.player.playVideo();
    }

    if (!this.iframe || window.getComputedStyle(this.iframe).display === 'none') {
      this.modal.querySelector('.cookie-warning').classList.remove('hide');
    } else {
      this.modal.querySelector('.cookie-warning').classList.add('hide');
    }

    document.body.classList.add('no-scroll-body');
  }

  closeVideoModal() {
    this.modal.style.display = 'none';
    if (this.player && this.player.stopVideo) {
      this.player.stopVideo();
    }
    document.body.classList.remove('no-scroll-body');
  }
}
